import React, { useEffect, useState } from "react";
import { Butterfly } from "./LogoMark";

/** Full-screen loader — a butterfly lifting off the ring. */
const Loader = ({ minMs = 900 }) => {
  const [gone, setGone] = useState(false);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), minMs);
    const t2 = setTimeout(() => setGone(true), minMs + 600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [minMs]);

  if (gone) return null;
  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center transition-opacity duration-500 ${fading ? "opacity-0" : "opacity-100"}`}
      style={{ background: "var(--ground)" }}
      data-testid="site-loader"
    >
      <div className="relative w-[160px] h-[140px] flex items-center justify-center">
        <svg viewBox="0 0 200 180" width="160" height="140" fill="none">
          {/* open ring, break at lower right */}
          <path
            d="M 40 90 C 40 50, 90 30, 130 40 C 170 50, 180 100, 150 130 C 130 150, 90 150, 70 140"
            stroke="#1C1A19"
            strokeWidth="1"
            fill="none"
          />
        </svg>
        <div className="absolute animate-butterfly-lift" style={{ top: 18, right: 34 }}>
          <Butterfly size={26} />
        </div>
      </div>
    </div>
  );
};

export default Loader;
